import { render, staticRenderFns } from "./UnauthorisedPage.vue?vue&type=template&id=0b5db7b6&scoped=true&"
import script from "./UnauthorisedPage.vue?vue&type=script&lang=js&"
export * from "./UnauthorisedPage.vue?vue&type=script&lang=js&"
import style0 from "./UnauthorisedPage.vue?vue&type=style&index=0&id=0b5db7b6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b5db7b6",
  null
  
)

export default component.exports